export const COMPANY_ID = '60ccb4354511e94f1c7a89b9';
export const REDIRECT = 'https://crehana.canny.io/feedback';
